import { Component, OnInit } from '@angular/core';
import { GeneralFunctionsService } from 'src/app/shared/general-functions.service';
import { Factuur, FactuurObject } from 'src/app/shared/model/factuur';

@Component({
  selector: 'app-factuur-view',
  templateUrl: './factuur-view.component.html',
  styleUrls: ['./factuur-view.component.less']
})
export class FactuurViewComponent implements OnInit {

  list = null;
  currentRecord = 1;
  factuurID : number;


  constructor() { }

  ngOnInit(): void {
  }



  selectionChanged(data: Array<FactuurObject>) {
      this.list = data;
      this.factuurID = data[0].ID;
  }

  objectChanged(data: any) {
    if (data.record)
      this.currentRecord = data.record;
    if (data.ID)
      this.factuurID = data.ID;

    console.log(this.factuurID)

  }

  factuurAdded(data:Factuur) {
      const object = new FactuurObject()
      object.ID = data.ID;
      object.ObjectID = data.ObjectID;
      this.list.unshift(object);
  }


}
